var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-5" }, [
    _vm._m(0),
    _c("div", { staticClass: "col-6 mt-3" }, [
      _c("div", [
        _c("strong", [_vm._v("Rut")]),
        _c("div", { staticClass: "ml-3" }, [
          _vm._v(" " + _vm._s(_vm.bidder.rut) + " ")
        ])
      ])
    ]),
    _c("div", { staticClass: "col-6 mt-3" }, [
      _c("div", [
        _c("strong", [_vm._v("Nombre")]),
        _c("div", { staticClass: "ml-3" }, [
          _vm._v(" " + _vm._s(_vm.bidder.nombre) + " ")
        ])
      ])
    ]),
    _c("div", { staticClass: "col-6 mt-3" }, [
      _c("div", [
        _c("strong", [_vm._v("Giro")]),
        _c("div", { staticClass: "ml-3" }, [
          _vm._v(" " + _vm._s(_vm.bidder.giro) + " ")
        ])
      ])
    ]),
    _c("div", { staticClass: "col-6 mt-3" }, [
      _c("div", [
        _c("strong", [_vm._v("Direccion")]),
        _c("div", { staticClass: "ml-3" }, [
          _vm._v(" " + _vm._s(_vm.bidder.direccion) + " ")
        ])
      ])
    ]),
    _c("div", { staticClass: "col-6 mt-3" }, [
      _c("div", [
        _c("strong", [_vm._v("Comuna")]),
        _c("div", { staticClass: "ml-3" }, [
          _vm._v(" " + _vm._s(_vm.bidder.comuna) + " ")
        ])
      ])
    ]),
    _c("div", { staticClass: "col-6 mt-3" }, [
      _c("div", [
        _c("strong", [_vm._v("Ciudad")]),
        _c("div", { staticClass: "ml-3" }, [
          _vm._v(" " + _vm._s(_vm.bidder.ciudad) + " ")
        ])
      ])
    ]),
    _c("div", { staticClass: "col-6 mt-3" }, [
      _c("div", [
        _c("strong", [_vm._v("Correo")]),
        _c("div", { staticClass: "ml-3" }, [
          _vm._v(" " + _vm._s(_vm.bidder.correo) + " ")
        ])
      ])
    ]),
    _c("div", { staticClass: "col-6 mt-3" }, [
      _c("div", [
        _c("strong", [_vm._v("Contacto")]),
        _c("div", { staticClass: "ml-3" }, [
          _vm._v(" " + _vm._s(_vm.bidder.telefono) + " ")
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", { staticClass: "text-primary mb-3" }, [_vm._v("Adjudicatario")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }